export enum NavbarActionButtons {
  STUDENTS = 'Students',
  INSIGHTS = 'Insights',
  SETTINGS = 'Config',
  FEEDBACK = 'Feedback',
}
